import type { MeshChannel } from "@interopio/gateway/mesh/api";
import { isRunningInConnectDesktop, parseStartingContext } from './desktop.ts';
import { tmpdir } from 'node:os';
import { createServer } from 'node:net';
import { join } from 'node:path';
import { IOGateway } from '@interopio/gateway';
import { GatewayServer } from '@interopio/gateway-server';

export function onGatewayStarted(log: IOGateway.Logging.Logger): (gateway: IOGateway.Gateway) => void {
    return (gateway) => {
        const info = JSON.stringify(gateway.info());
        if (isRunningInConnectDesktop()) {
            const env = process.env["GLUE-ENV"] || "DEMO";
            const region = process.env["GLUE-REGION"] || "INTEROP.IO";
            const user = process.env.USERNAME ?? process.env.USER;
            const pipe = `glue42-${env}-${region}-${user}`;
            const pipeName = (process.platform === 'win32') ? `\\\\.\\pipe\\${pipe}` : `${join(tmpdir(), pipe + ".sock")}`;
            log.info(`gateway started: ${info}, opening ${pipeName}`);
            const server = createServer((stream) => {
                log.info(`stream connected, sending info...`);
                stream.write(info);
                stream.end(() => {
                    server.close();
                });
            });
            server.listen(pipeName);
        }
        else {
            log.info(`gateway started: ${info}`);
        }
    }
}


export async function serverGatewayConfig(gateway: {
                                              enabled?: boolean,
                                              contexts: {
                                                  lifetime?: 'ref-counted' | 'ownership' | 'retained'
                                              }
                                          },
                                          bridge: {
                                              meshChannel: MeshChannel,
                                              wsPingInterval?: number
                                          }, env = process.env): Promise<GatewayServer.ServerConfig['gateway']> {
    let enabled = gateway.enabled;
    if (enabled === undefined) {
        if (isRunningInConnectDesktop(env)) {
            enabled = parseStartingContext(env)?.gatewayApp === true;
        }
    }
    let contextsLifetime = gateway.contexts.lifetime;
    if (contextsLifetime === undefined) {
        if (isRunningInConnectDesktop(env)) {
            contextsLifetime = 'retained';
        }
    }
    if (enabled) {
        // const { WebSocket: websocket } = (await import('ws')) as unknown as { WebSocket: typeof WebSocket };
        return {
            // globals: { websocket },
            clients: {
                inactive_seconds: 0,
            },
            ping: bridge.wsPingInterval ?? undefined,
            mesh: {
                channel: bridge.meshChannel
            },
            contexts: {
                lifetime: contextsLifetime,
                visibility: [
                    { context: /___channel___.+/, restrictions: 'cluster' },
                    { context: /T42\..*/, restrictions: 'local' },
                    { context: "___platform_prefs___", restrictions: 'local' },
                    { context: /___workspace___.+/, restrictions: 'local' },
                    { context: /___window-hibernation___.+/, restrictions: 'local' },
                    { context: /___instance___.+/, restrictions: 'local' },
                    { context: /___window___.+/, restrictions: 'local' },
                    { restrictions: 'cluster' }
                ]
            },
            methods: {
                visibility: [
                    { method: /T42\..*/, restrictions: 'local' },
                    { restrictions: 'cluster' }
                ]
            },
            peers: {
                visibility: [
                    { domain: 'context', restrictions: 'cluster' },
                    { domain: 'interop', restrictions: 'cluster' },
                    { domain: 'bus', restrictions: 'local' }
                ]
            }
        }
    }
}
